import { NgClass } from '@angular/common'
import { Component } from '@angular/core'
import { FieldWrapper, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core'
import { TranslatePipe } from '@ngx-translate/core'
import { SvgIconComponent } from 'angular-svg-icon'
import { NzFormControlComponent } from 'ng-zorro-antd/form'

import { FormlyFieldProps } from '../../types/common.types'

export interface NzFormFieldWrapperProps extends FormlyFieldProps {
  help?: string
  showHelp?: boolean
  helpOverCallback?: (field: NzFormFieldWrapperConfig) => void
  helpLeaveCallback?: (field: NzFormFieldWrapperConfig) => void
}
export type NzFormFieldWrapperConfig =
  FormlyFieldConfig<NzFormFieldWrapperProps>

@Component({
  selector: 'app-nz-form-field-wrapper',
  standalone: true,
  imports: [
    NzFormControlComponent,
    FormlyModule,
    NgClass,
    SvgIconComponent,
    TranslatePipe,
  ],
  templateUrl: './nz-form-field-wrapper.component.html',
})
export class NzFormFieldWrapperComponent extends FieldWrapper<NzFormFieldWrapperConfig> {
  public get errorState(): 'error' | '' {
    return this.showError ? 'error' : ''
  }
}
